import React from 'react';
import Video from 'components/video';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { imageSourceBreakpoints } from 'js/breakpoints';
import {
  getVideoSourceData,
  getResponsiveVideoPreviewImageSources,
} from 'js/video-source-utils';

const buildVideoPreviewMobilePortraitSources = imageSrc => {
  return [
    {
      imageSrc,
      width: 350,
      height: 623,
      media: imageSourceBreakpoints.xs,
    },
    {
      imageSrc,
      width: 400,
      height: 712,
      media: imageSourceBreakpoints.s,
    },
  ];
};

const buildVideoPreviewDesktopPortraitSources = () => {
  return [];
};

const buildVideoPreviewMobileLandscapeSources = imageSrc => {
  return [
    {
      imageSrc,
      width: 350,
      height: 197,
      media: imageSourceBreakpoints.xs,
    },
    {
      imageSrc,
      width: 728,
      height: 410,
      media: imageSourceBreakpoints.s,
    },
  ];
};

const buildVideoPreviewDesktopLandscapeSources = imageSrc => {
  return [
    {
      imageSrc: imageSrc,
      width: 629,
      height: 354,
      media: imageSourceBreakpoints.m,
    },
    {
      imageSrc: imageSrc,
      width: 905,
      height: 510,
      media: imageSourceBreakpoints.l,
    },
  ];
};

const VideoBlock = ({ heading, video, place }) => {
  const { orientation } = getVideoSourceData(
    video.landscapeSource,
    video.portraitSource
  );

  return video ? (
    <div
      className={cn('video-block', {
        [`video-block_in-${place}`]: place,
      })}
    >
      <div className="video-block__container">
        {heading && <h2 className="video-block__heading">{heading}</h2>}
        <Video
          {...video}
          imageSettings={{
            className: `image_size_video-block-orientation-${orientation}`,
            sources: getResponsiveVideoPreviewImageSources({
              landscapeSource: video.landscapeSource,
              portraitSource: video.portraitSource,
              buildVideoPreviewMobilePortraitSources,
              buildVideoPreviewDesktopPortraitSources,
              buildVideoPreviewMobileLandscapeSources,
              buildVideoPreviewDesktopLandscapeSources,
            }),
            loading: 'lazy',
          }}
        />
      </div>
    </div>
  ) : null;
};

VideoBlock.propTypes = {
  heading: PropTypes.string,
  video: PropTypes.exact(Video.propTypes),
  place: PropTypes.string,
};

export default VideoBlock;
